import { siteName } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-open-line text-base text-background-50"></i>
              </span>
              <span className="text-lg font-bold font-heading text-background-50">{siteName}</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              韩漫网是专注韩国漫画的综合性韩漫网站，提供漫画韩漫网址导航与海量韩漫免费在线阅读。下拉式阅读、实时更新、全集畅享，是漫迷追更热门完结韩漫的首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#hero" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#topics" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门话题</a>
              <a href="#ranking" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">人气榜单</a>
              <a href="#index" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">分类索引</a>
              <a href="#faq" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">推荐专题</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-300 whitespace-nowrap">本月新番速递</span>
              <span className="text-sm text-background-300 whitespace-nowrap">完结神作补完</span>
              <span className="text-sm text-background-300 whitespace-nowrap">冷门佳作发掘</span>
              <span className="text-sm text-background-300 whitespace-nowrap">恋爱漫画特辑</span>
              <span className="text-sm text-background-300 whitespace-nowrap">热血战斗图鉴</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              期待与更多优秀的内容平台、漫画作者和翻译团队建立合作关系，共同为漫迷打造更丰富的阅读生态。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteName} 版权所有
          </p>
          <p className="text-xs text-background-400">
            本站内容仅供学习交流，请支持正版漫画
          </p>
        </div>
      </div>
    </footer>
  );
}